/**
 * Finished work (punch list F112, F117, 30 Oct 2026): the reader's local days, and the page's
 * "Download for Excel".
 *
 * A finish is a moment; the day it falls on is the READER's, as on My calendar. So the range the
 * page asks for is in local days, and each row's date is printed in local time.
 *
 * The download is CSV through `csvCell`, the punch list's: task and project names are typed by
 * people, so no cell may open in Excel as a formula.
 */
import type { FinishedStageRow } from "@fieldpath/shared";

import { csvCell } from "./punchCsv";

const pad = (n: number) => String(n).padStart(2, "0");

/** A Date's LOCAL calendar day, YYYY-MM-DD. */
export function localDay(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** The local day `days` before `d` (negative goes forward). */
export function daysBefore(d: Date, days: number): string {
  return localDay(new Date(d.getFullYear(), d.getMonth(), d.getDate() - days));
}

export const FINISHED_CSV_COLUMNS: readonly (readonly [string, (r: FinishedStageRow) => string | null])[] = [
  ["Finished", (r) => localDay(new Date(r.completedAt))],
  ["Stage", (r) => r.stageName],
  ["Task", (r) => r.taskTitle],
  ["Deliverable", (r) => r.deliverableName],
  ["Project", (r) => r.projectName],
  ["Client", (r) => r.clientName],
];

export function finishedCsv(rows: readonly FinishedStageRow[]): string {
  const lines = [FINISHED_CSV_COLUMNS.map(([header]) => csvCell(header)).join(",")];
  for (const row of rows) lines.push(FINISHED_CSV_COLUMNS.map(([, get]) => csvCell(get(row))).join(","));
  return `﻿${lines.join("\r\n")}\r\n`;
}
